import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './endpoint.config.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends ConnectionService {
  getSummary(date: string, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_SUMMARY").replace("{{date}}", date).replace("{{currentLocationId}}", currentLocationId);
    this.CallApi('get', endpoint, {}, null, (res) => {
      sucFun(res)
    }, (err) => {

    });
  }

  getNewShipments(date: string, take, skip, sucFun, errFun, ) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_NEW_SHIPMENTS").replace("{{date}}", date).replace("{{currentLocationId}}", currentLocationId).replace("{{take}}", take).replace("{{skip}}", skip);;

    this.CallApi('get', endpoint, {}, null, (res) => {
      sucFun(res)
    }, (err) => {

    });
  }
  getReturnedShipment(date: string, take, skip, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_RETURNED_SHIPMENTS").replace("{{date}}", date).replace("{{currentLocationId}}", currentLocationId).replace("{{take}}", take).replace("{{skip}}", skip);
    this.CallApi('get', endpoint, { }, null, (res) => {
      sucFun(res)
    }, (err) => {

    });
  }
  getDeliveryCode(sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_DELIVERY_CODE").replace("{{currentLocationId}}", currentLocationId);
    this.CallApi('get', endpoint, {}, null, (res) => {
      sucFun(res);
    }, (err) => {
        errFun(err);
    });
  }

  constructor(http: HttpClient, private configs: ConfigService) {
    super(http);
  }
}


